import React from 'react';
import { BRAND } from '../../lib/brand';

// Class component — error boundaries need componentDidCatch, which has no hook equivalent.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <img src={BRAND.logo} alt="" style={styles.logo} />
          <h1 style={styles.title}>Something went wrong</h1>
          <p style={styles.text}>
            Sorry about that. Reloading usually sorts it. If it keeps happening,
            let {BRAND.name} know at{' '}
            <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>.
          </p>
          <button
            className="btn btn-primary"
            style={styles.button}
            onClick={() => window.location.reload()}
          >
            Reload the app
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'var(--cream)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
  },
  card: {
    background: 'var(--white)',
    borderRadius: 'var(--radius-xl)',
    boxShadow: 'var(--shadow-lg)',
    padding: '2rem 1.75rem',
    maxWidth: '380px',
    width: '100%',
    textAlign: 'center',
  },
  logo: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid rgba(var(--terracotta-rgb),0.4)',
    margin: '0 auto 1rem',
  },
  title: {
    fontSize: '1.35rem',
    marginBottom: '0.6rem',
  },
  text: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: 'var(--charcoal)',
    marginBottom: '1.25rem',
  },
  button: {
    width: '100%',
    justifyContent: 'center',
    padding: '0.8rem',
    fontSize: '1rem',
  },
};
